<template>
    <v-app>
        <!-- Header fixat -->
        <v-app-bar app flat height="80" color="#00819d" dark>
            <!-- Logo -->
            <v-toolbar-title class="me-6 logo-container">
                <img :src="adminLogoUrl" alt="Traycco" class="logo-img"/>
            </v-toolbar-title>

            <v-spacer/>

            <!-- Botons acció -->
            <v-spacer/>
            <div class="d-flex align-center gap-buttons">
                <PerformanceReportButton :user="currentUser" />
                <v-btn
                    variant="outlined"
                    color="#ffa189"
                    class="font-weight-bold"
                    density="compact"
                    height="30"
                    min-width="100"
                    size="small"
                    style="margin-right: 5px;"
                    @click="logout"
                >
                    Salir
                </v-btn>

                <v-btn
                    variant="outlined"
                    color="#00C2A8"
                    class="font-weight-bold"
                    density="compact"
                    height="30"
                    min-width="100"
                    size="small"
                    style="margin-right: 5px;"
                    :to="{ path: '/dashboard' }"
                    v-if="!isWarehouse"
                    >
                    Panel de control
                </v-btn>

                <v-btn
                    variant="outlined"
                    color="#00C2A8"
                    class="font-weight-bold"
                    density="compact"
                    height="30"
                    min-width="100"
                    size="small"
                    style="margin-right: 20px;"
                    :to="{ path: '/cliente' }"
                    v-if="!isWarehouse"
                >
                    Web cliente
                </v-btn>
            </div>
        </v-app-bar>

        <!-- Contingut central -->
        <v-main app>
            <!-- Breadcrumb -->
            <v-container v-if="breadcrumbs.length" class="py-0 px-4 bg-grey-lighten-3" fluid>
                <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
            </v-container>

            <v-container fluid class="pa-4">
                <router-view/>
            </v-container>
        </v-main>

        <!-- Peu de pàgina -->
        <v-footer app padless color="#001921">
            <v-col class="text-center text-white py-4" cols="12">
                © {{ new Date().getFullYear() }} Traycco
                <span class="ml-4"><MaterialsAccessButton /></span>
            </v-col>
        </v-footer>
    </v-app>
</template>

<script setup>
import MaterialsAccessButton from '@/components/MaterialsAccessButton.vue'
import {onMounted, ref, provide} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {computed} from 'vue'
import axios from 'axios'
import PerformanceReportButton from '@/components/common/PerformanceReportButton.vue'

const route = useRoute()
const router = useRouter()

const breadcrumbs = computed(() => {
    return (route.meta?.breadcrumb ?? []).map(item => ({
        title: item.text,
        disabled: !item.to,
        to: item.to || undefined
    }))
})

const logout = () => {
    const redirectPath = '/'
    localStorage.clear()

    router.push(redirectPath)
}

const isWarehouse = ref(false)
const currentUser = ref(null)
const adminLogoUrl = '/images/logo_blanc.png'

onMounted(async () => {
    const { data: user } = await axios.get('/api/user', {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    })

    currentUser.value = user
    isWarehouse.value = user.role === 'warehouse'

    if (isWarehouse.value && router.currentRoute.value.path !== '/dashboard/stock') {
        router.replace('/dashboard/stock')
    }
})

provide('isWarehouse', isWarehouse)
</script>

<style scoped>
.menu-area {
    max-width: 60vw;
    overflow-wrap: anywhere;
}

.gap-buttons > * {
    margin-left: 8px;
}

.logo-container {
    max-width: 180px;
    flex-shrink: 0;
}

.logo-img {
    max-height: 48px;
    width: auto;
    height: auto;
    max-width: 100%;
    object-fit: contain;
}

.menu-link {
    color: white !important;
    font-weight: bold;
    font-size: 14px;
    text-transform: none;
    min-width: unset;
    padding: 6px 12px;
    background-color: transparent !important;
    box-shadow: none !important;
    opacity: 1 !important;
}

.menu-link:hover {
    text-decoration: underline;
    background-color: transparent !important;
}

</style>
